module.exports = {"pageTitleText":"Alert Setting","createText":"Add Rule","ruleName":"Rule Name","alertRuleQuery":"Query","alertChannelName":"Channel","alertValue":"Alert Value","alertValueUnit":"Value Unit","isAlerting":"Alerting","currentValue":"Current Value","alertMessage":"Alert Message","alertWhen":"Above/Under","alertValueInfo":"Alert Info","ruleTest":"Test","sections":{"essential":"Essential"}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US/alertrules.json
// module id = oVTY
// module chunks = 3